import { ReactElement } from 'react';
import FormGroup from '~/components/form/FormGroup';
import ValibotFieldCheckbox from '~/components/valibot/ValibotFieldCheckbox';
import { FormHorizontal } from '~/components/form/layout';
import ValibotFieldInput from '~/components/valibot/ValibotFieldInput';
import { useValibotFieldSingleValue } from '~/components/valibot/ValibotForm';

export default function BreCinematicSubmitForm(): ReactElement {
  const photos = useValibotFieldSingleValue('aerial_photos');


  return (
    <FormGroup>
      <label className="flex items-center gap-2" htmlFor="self_edited">
        <ValibotFieldCheckbox id="self_edited" name="self_edited" />
        Self-edited video
      </label>
      {photos && (
        <FormHorizontal name="editing_credits" label="Editing Credits">
          <ValibotFieldInput name="editing_credits" type="number" />
        </FormHorizontal>
      )}
    </FormGroup>
  );
}
